<div class="center-y gap-2">
  <input
    type="radio"
    [disabled]="disabled"
    [checked]="checked || valueChecked === value"
    [class.error]="error"
    [name]="name"
    [value]="value"
    (change)="onSelectionChange()"
  />
  <label class="label-text" [class.disabled]="disabled">
    <ng-content></ng-content>
  </label>
</div>
<label *ngIf="error && errorMessage" class="error-text">{{ errorMessage }}</label>
